module.exports = __webpack_public_path__ + "static/media/cancelled.565c49cf.gif";